// extracted by mini-css-extract-plugin
export var container = "_3w-0";
export var icon = "_3w-1";
export var text = "_3w-2";